import { useHistory } from 'react-router-dom'
import { useState, useReducer, useEffect } from 'react'
import swal from 'sweetalert'
import Action from '../../model/Action'
import { Entidade } from '../../model/Entidade'
import FormState from '../../model/FormState'
import Localizacao from '../../model/Localizacao'
import TipoEntidade from '../../model/TipoEntidade'
import { useProvider } from '../../provider/Provider'
import EntidadeService from '../../services/EntidadeService'

export default function useFormState() {
    const { loadEntidades, currentEntidade } = useProvider()
    const initialState: FormState = {
        nome: currentEntidade.nome,
        telefone: currentEntidade.telefone,
        site: currentEntidade.site,
        email: currentEntidade.email,
        descricao: currentEntidade.descricao,
        areaDeAtuacao: currentEntidade.areaDeAtuacao,
        cidade: currentEntidade.localizacao.cidade,
        bairro: currentEntidade.localizacao.bairro,
        logradouro: currentEntidade.localizacao.logradouro,
        numero: currentEntidade.localizacao.numero.toString(),
        complemento: currentEntidade.localizacao.complemento,
        tipoEntidade: tipoEntidadeToOptions(currentEntidade.tipoEntidade),
        logo: currentEntidade.logo,
        metas: currentEntidade.metas,
        pitch: currentEntidade.pitch,
        publicoAlvo: currentEntidade.publicoAlvo,
        fase: currentEntidade.fase,
        faturamento: currentEntidade.faturamento,
        tamanhoEquipe: currentEntidade.tamanhoEquipe
    }
    const [formState, dispatch] = useReducer(reducer, initialState)
    const [tipoEntidades, setTipoEntidades] = useState<TipoEntidade[]>([])
    const history = useHistory()

    useEffect(() => {
        EntidadeService.getTipoEntidades().then((data) => {
            setTipoEntidades(data)
        })
    }, [])

    function optionToTipoEntidade(list: any[]): TipoEntidade[] {
        return list.map((l) => {return { id: l.id, nome: l.name }})
    }

    function tipoEntidadeToOptions(list: TipoEntidade[]): any[] {
        return list.map((l) => {return { id: l.id, name: l.nome }})
    }

    const handleSubmit = () => {
        const newLocalizacao: Localizacao = {
            logradouro: formState.logradouro,
            numero: +formState.numero,
            bairro: formState.bairro,
            cidade: formState.cidade,
            complemento: formState.complemento
        }

        const entidade: Entidade = {
            nome: formState.nome,
            telefone: formState.telefone,
            site: formState.site,
            email: formState.email,
            descricao: formState.descricao,
            areaDeAtuacao: formState.areaDeAtuacao,
            localizacao: newLocalizacao,
            tipoEntidade: optionToTipoEntidade(formState.tipoEntidade),
            fase: formState.fase!,
            faturamento: +formState.faturamento!,
            logo: formState.logo,
            metas: formState.metas,
            pitch: formState.pitch,
            tamanhoEquipe: +formState.tamanhoEquipe!,
            publicoAlvo: formState.publicoAlvo!,
            admin: currentEntidade.admin
        }

        EntidadeService.update(currentEntidade.id!, entidade).then(() => {
            loadEntidades()

            swal({
                title: 'Atualização salva com sucesso!',
                icon: 'success',
                buttons: [false],
                timer: 2000
            })
            history.push('/buscar')
        }).catch(() => {
            swal({
                title: 'Falha na atualização dos dados!',
                icon: 'error',
                buttons: [false],
                timer: 2000
            })
        })
    }

    return {
        tipoEntidades,
        formState,
        dispatch,
        handleSubmit
    }
}

const reducer = (formState: FormState, action: Action): FormState => {
    switch (action.type) {
    case 'setNome':
        return { ...formState, nome: action.payload }
    case 'setTelefone':
        return { ...formState, telefone: action.payload }
    case 'setSite':
        return { ...formState, site: action.payload }
    case 'setEmail':
        return { ...formState, email: action.payload }
    case 'setDescricao':
        return { ...formState, descricao: action.payload }
    case 'setAreaDeAtuacao':
        return { ...formState, areaDeAtuacao: action.payload }
    case 'setCidade':
        return { ...formState, cidade: action.payload }
    case 'setBairro':
        return { ...formState, bairro: action.payload }
    case 'setLogradouro':
        return { ...formState, logradouro: action.payload }
    case 'setNumero':
        return { ...formState, numero: action.payload }
    case 'setComplemento':
        return { ...formState, complemento: action.payload }
    case 'setTipoEntidade':
        return { ...formState, tipoEntidade: action.payload }
    case 'setImagem':
        return { ...formState, image: action.payload }
    case 'setLogo':
        return { ...formState, logo: action.payload }
    case 'setPublicoAlvo':
        return { ...formState, publicoAlvo: action.payload }
    case 'setTamanhoEquipe':
        return { ...formState, tamanhoEquipe: action.payload }
    case 'setFaturamento':
        return { ...formState, faturamento: action.payload }
    case 'setMetas':
        return { ...formState, metas: action.payload }
    case 'setPitch':
        return { ...formState, pitch: action.payload }
    case 'setFase':
        return { ...formState, fase: action.payload }
    default:
        return formState
    }
}
